/* eslint-disable */

define(() => {
  class NestedFields {
    constructor() {
      this.$addFields = $('.js-add-fields');
      this.$employmentContainer = $('.js-employments-fields');
      this.deleteFieldBtn = '.js-delete-field';

      this.addEmptyFields = this.addEmptyFields.bind(this);

      this.bindEvents();
    }

    bindEvents() {
      this.$addFields.on('click', this.addEmptyFields);
      $(document).on('click', this.deleteFieldBtn, this.deleteField);
    }

    addEmptyFields(event) {
      const $target = $(event.currentTarget);
      const data = $target.data();
      const templateSelector = data.template;
      const timestamp = new Date().getTime();
      const $container = $(data.container);
      const $template = $(`.${templateSelector}`).clone();
      const $employmentHistory = $template.find('.js-employment-history');
      const experienceDateId = `experience-end-${timestamp}`;

      if ($employmentHistory.length) {
        const index = $employmentHistory.data('index');
        $employmentHistory.data({ index: index.replace('_new', timestamp) });
      }

      $template.find('#experience-end-_new').attr('id', experienceDateId);
      $template.find('[data-target="#experience-end-_new"]').attr('data-target', `#${experienceDateId}`);
      $template.removeClass(`${templateSelector} dn`);
      $template.find('[name]').each((idx, input) => {
        input.name = input.name.replace('_new', timestamp);
      });
      $template
        .find('.chosen-select-with-search')
        .show()
        .next()
        .remove();

      $container.append($template);
      $(document).trigger('interests:update', $container.children().last());
    }

    deleteField(event) {
      const $target = $(event.currentTarget);
      const $parent = $target.parents('.js-field');
      const $destroy = $parent.find('.js-hidden-delete');

      if ($destroy.length) {
        $parent.addClass('dn');
        return $destroy.val(true);
      }

      $parent.remove();
    }
  }

  return NestedFields;
});
